angular.module('zc.projects')

.component 'campaignCheckStatus',
  bindings:
    campaign: '<'
  template: """
  <i
    tooltip="{{ 'projectsCampaigns.components.campaignCheckStatus.confirmDelivery' | translate }}"
    ng-if="$ctrl.campaign.is_fired && $ctrl.campaign.current_status === \'active\'"
    class="fa fa-check-circle"
    zc-master-only>
  </i>
  """



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/components/campaign_check_status.js.coffee